import { fetchToken, getToken } from './auth';
import { v4 as uuidv4 } from 'uuid';
import { notifyError } from './notifications';
import axiosRetry from 'axios-retry';
import { getErrorMessage, getErrorMessageFromCode } from './errors';

export const setupInterceptors = axiosInstance => {
  axiosRetry(axiosInstance, {
      retries: 3,
      retryCondition: async error => {
        const isRetryableError = axiosRetry.isRetryableError(error);

        // Não fazer retry de requisições do serviço de token para evitar loop infinito
        const isTokenRequest = error.config.url?.includes('auth/GenerateToken');

        if (error.response?.status === 401 && !error.config._isRetry && !isTokenRequest) {
          error.config._isRetry = true;
          try {
            const newToken = await fetchToken();
            error.config.headers['Authorization'] = `Bearer ${newToken}`;
            return true;
          } catch {
            return false;
          }
        }

        return isRetryableError;
      },
      retryDelay: () => 2000 // 2 SEG
  });

  axiosInstance.interceptors.request.use(
    config => {
      const token = getToken();

      config.headers = {
        ...config.headers,
        accept: 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
        bsUsername: process.env.REACT_APP_Username,
        bsUser: process.env.REACT_APP_BsUser,
        bsSolution: process.env.REACT_APP_BsSolution,
        bsSubscriptionKey: process.env.REACT_APP_BsSubscriptionKey,
        traceparent: uuidv4(),
      };

      return config;
    },
    error => {
      return Promise.reject(error);
    },
  );

  axiosInstance.interceptors.response.use(
    response => {
      return response;
    },
    async error => {
      let errorMessage = getErrorMessage('DEFAULT_MESSAGE');

      const { data } = error.response || {};
      const code = data?.code;

      if (!error.config._isNotified) {
        error.config._isNotified = true;

        if (data?.errors?.length) {
          errorMessage = data.errors.map(err => getErrorMessageFromCode(err.code)).join(', ');
        } else if (code) {
          errorMessage = getErrorMessageFromCode(code);
        } else if (!data && error.code) {
          errorMessage = getErrorMessageFromCode(error.code);
        }

        notifyError(errorMessage);
      }

      return Promise.reject(error);
    },
  );
};
